module.exports = __webpack_public_path__ + "static/media/documento.f96cdbde.svg";